import { BusinessSeller, getBusinessSeller } from '@/entities/businessSeller';
import { BusinessSellerService } from '@/services/businessSellerService';
import { useEffect, useState } from 'react';

export const useBusinessSeller = (businessId: number) => {
  const [ businessSellers, setBusinessSellers ] = useState<getBusinessSeller>();
  const [errorCreateBusinessSellers, setErrorCreateBusinessSellers] = useState(false);
  const [errorUpdateBusinessSellers, setErrorUpdateBusinessSellers] = useState(false);
  
  useEffect(()=>{
    
    fetchBusinessSellers(businessId);
  },[]);

  const  fetchBusinessSellers = async (businessId: number) => {
    try{
      const response = await BusinessSellerService.getBusinessSeller(businessId);
      if(response){
        setBusinessSellers(response);
        return response;
      }
  
    }catch(e){
      console.error(`Error ao carregar dados ${e}`);
    }
                  
  };

  const upsertBusinessSeller = async (businessId: number, sellerId: number) => {
    try {
        const dado = await BusinessSellerService.upsertBusinessSeller(Number(businessId),sellerId);
        return dado;
    } catch(e){
        console.error(e);
        setErrorCreateBusinessSellers(true);
    }
  }

  const createBusinessSeller = async (businessSeller: BusinessSeller)=>{
    try{
      await BusinessSellerService.createBusinessSeller(businessSeller);
    }catch(e){
      console.error(`Deu erro meu chapa ${e}`);
      setErrorCreateBusinessSellers(true);
    }
  };
  const deleteBusinessSeller = async (id:number, businessId:number) => {
    try{
      await BusinessSellerService.deleteBusinessSeller(id, businessId);
    }catch(e){
      console.error(`Deu erro meu chapa ${e}`);
    }
  };

  return{
    businessSellers,
    createBusinessSeller,
    fetchBusinessSellers,
    deleteBusinessSeller,
    upsertBusinessSeller
  };
};
